<template>
    <div>
        <b-alert :show="showNoTranscriptAlert" variant="warning" dismissible>
            <p>Warning! Transcript cannot be delivered.  No Transcript is attached.</p>
        </b-alert>

        <b-table bordered striped small hover :items="orders" :fields="fields">
            <template #cell(toBeDelivered)="data">
                <b-form-checkbox v-model="data.item.toBeDelivered" v-if="!data.item.delivered && data.item.order.subStatusDeliveryState !== false" v-on:change="ordersToBeDeliveredChanged"></b-form-checkbox>
            </template>

            <template #cell(order.subStatusDisplayName)="data">
                <div class="d-flex flex-row">
                    <div class="flex-fill" :id="'tooltip-' + data.item.order.orderId">
                        <span v-if="workItemCompleted || data.item.delivered">Delivered</span>
                        <span v-else-if="data.item.order.subStatusDeliveryState == null">n/a</span>
                        <span style="color:green;" v-else-if="data.item.order.subStatusDeliveryState">Ready</span>
                        <span style="color:red;" v-else>Not Ready</span>
                    </div>
                    <b-button variant="outline-secondary"
                              title="Edit Delivery Sub Statuses"
                              @click="editSubStatus(data.item.order)"
                              size="sm"
                              v-if="!forOrderDelivery && !readonly && !workItemCompleted && !data.item.delivered && (canModifyAudioSubStatus || canModifyLogNotesSubStatus || canModifyReleaseApprovalSubStatus || canModifyDepositSubStatus)"><i class="fas fa-edit"></i></b-button>
                    <b-button variant="outline-secondary"
                              title="Reset Delivered Status"
                              @click="resetDeliveredStatus(data.item.order)"
                              size="sm"
                              v-if="!forOrderDelivery && !readonly && (workItemCompleted || data.item.delivered) && canResetDeliveredStatus"><i class="fas fa-times"></i></b-button>
                </div>
                <b-tooltip v-if="data.item.order.subStatus.displayName.length" :target="'tooltip-' + data.item.order.orderId" triggers="hover">
                    <div v-html="formatSubStatusString(data.item.order.subStatus.displayName)"></div>
                </b-tooltip>
            </template>

            <template #cell(order.deliveryContacts)="data">
                <b-tooltip :target="'delivery-contacts-' + data.item.order.orderId" triggers="hover" v-if="data.item.deliveryContacts.length && canViewDeliveryContactDetails">
                    <span v-html="renderDeliveryContacts(data.item.deliveryContacts)"></span>
                </b-tooltip>


                <div class="d-flex flex-row">
                    <div class="flex-fill" :id="'delivery-contacts-' + data.item.order.orderId">
                        {{ data.item.deliveryContacts.length }} contact/s<br />
                    </div>
                    <b-dropdown size="sm" variant="outline-secondary" right>
                        <b-dropdown-item v-on:click="editDistributionList(data.item)"
                                         v-if="!forOrderDelivery && !readonly && canModifyDeliveryContacts">
                            Edit Distribution List
                        </b-dropdown-item>
                        <b-dropdown-item :href="data.item.emailLink" v-if="!hideDeliveryInfo && canViewDeliveryContactDetails && data.item.emailLink">Create Email</b-dropdown-item>
                        <b-dropdown-item v-on:click="copyTranscriptLinkToClipboard(data.item)" v-if="!hideDeliveryInfo && canViewDeliveryContactDetails && data.item.transcriptLink">Link to Transcript</b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>

            <!--<template #cell(copiesDelivered)="data">
            <b-form-input v-model="data.item.copiesDelivered" size="sm" style="width:50px;" :disabled="!data.item.toBeDelivered" class="w-10" v-on:change="ordersToBeDeliveredChanged">{{ data.item.copiesDelivered }}</b-form-input>
        </template>-->
            <!--<template #cell(deliveredOnTime)="data">
            <b-form-checkbox v-model="data.item.deliveredOnTime" :disabled="!data.item.toBeDelivered" switch v-on:change="ordersToBeDeliveredChanged">{{ data.item.deliveredOnTime ? 'Yes' : 'No' }}</b-form-checkbox>
        </template>-->
            <!--<template #cell(deliveredLateReason)="data">
            <div class="d-flex flex-row">
                <b-form-select v-model="data.item.deliveredLateReason" :options="allDeliveredLateReasonOptions" size="sm" class="flex-fill" :disabled="!data.item.toBeDelivered || data.item.deliveredOnTime" v-on:change="deliveredLateReasonChanged(data.item)"></b-form-select>
                <b-button variant="outline-secondary" title="Edit Delivered Late Reason Text/Comment" v-on:click="editDeliveredLateReasonText(data.item)" size="sm" :disabled="!data.item.toBeDelivered || data.item.deliveredOnTime"><i class="fas fa-edit"></i></b-button>
            </div>
        </template>-->

            <template #row-details="data">

                <b-row class="row bg-white m-1 pt-1 pb-1">

                    <b-col cols="3" class="pb-0">

                        <b-form-group id="nr-of-copies"
                                      label-cols-lg="8"
                                      content-cols-lg="4"
                                      label="Number of copies:"
                                      label-for="number-copies"
                                      label-size="sm"
                                      class="mb-0">
                            <b-form-input id="number-copies" v-model="data.item.copiesDelivered" size="sm" :disabled="!data.item.toBeDelivered" v-on:change="ordersToBeDeliveredChanged">{{ data.item.copiesDelivered }}</b-form-input>
                        </b-form-group>

                    </b-col>

                    <b-col cols="3" class="pb-0">
                        <b-form-group id="delivered-on-time"
                                      label-cols-lg="8"
                                      content-cols-lg="4"
                                      label=" Delivered on time:"
                                      label-for="on-time"
                                      label-size="sm"
                                      class="mb-0">
                            <b-form-checkbox v-model="data.item.deliveredOnTime" size="sm" class="pt-1" :disabled="!data.item.toBeDelivered" switch v-on:change="ordersToBeDeliveredChanged">{{ data.item.deliveredOnTime ? 'Yes' : 'No' }}</b-form-checkbox>
                        </b-form-group>
                    </b-col>

                    <b-col>

                        <b-input-group class="mb-0">
                            <b-form-select v-model="data.item.deliveredLateReason" :options="allDeliveredLateReasonOptions" size="sm" class="" :disabled="!data.item.toBeDelivered || data.item.deliveredOnTime" v-on:change="deliveredLateReasonChanged(data.item)"></b-form-select>
                            <b-input-group-append>
                                <b-button variant="outline-secondary" title="Edit Delivered Late Reason Text/Comment" class="align-right" v-on:click="editDeliveredLateReasonText(data.item)" size="sm" :disabled="!data.item.toBeDelivered || data.item.deliveredOnTime"><i class="fas fa-edit"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
            </template>
        </b-table>

        <b-modal size="md" centered title="Late Reason Text/Comment" id="delivered-late-reason-text">
            <b-form-textarea v-model="currentDeliveredLateReasonText" rows="3"></b-form-textarea>

            <template #modal-footer>
                <b-button size="sm" variant="secondary" @click="hideModal()">Cancel</b-button>
                <b-button size="sm" variant="success" @click="updateDeliveredLateReasonText()">Save</b-button>
            </template>

        </b-modal>

        <b-modal size="md" centered title="Edit Sub Status" id="sub-status-modal">
            <p>Sub Status for <b>Order {{ this.orderNumber }}</b>:</p>
            <b-container class="bv-example-row">
                <b-row class="mb-2">
                    <b-col cols="6">Audio Status:</b-col>
                    <b-col cols="6"><b-form-select v-model="selectedAudioSubStatus" :options="allAudioSubStatusOptions" size="sm" :disabled="!canModifyAudioSubStatus"></b-form-select></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="6">Log Notes Status:</b-col>
                    <b-col cols="6"><b-form-select v-model="selectedLogNotesSubStatus" :options="allLogNotesSubStatusOptions" size="sm" :disabled="!canModifyLogNotesSubStatus"></b-form-select></b-col>
                </b-row>

                <b-row class="mb-2">
                    <b-col cols="6">Release Status:</b-col>
                    <b-col cols="6"> <b-form-select v-model="selectedReleaseApprovalSubStatus" :options="allReleaseApprovalSubStatusOptions" size="sm" :disabled="!canModifyReleaseApprovalSubStatus"></b-form-select></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="6">Payment Status:</b-col>
                    <b-col cols="6"><b-form-select v-model="selectedDepositSubStatus" variant="secondary" :options="allDepositSubStatusOptions" size="sm" :disabled="!canModifyDepositSubStatus"></b-form-select></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="6">Vetting Status:</b-col>
                    <b-col cols="6"><b-form-select v-model="selectedVettingSubStatus" variant="secondary" :options="allVettingSubStatusOptions" size="sm" :disabled="!canModifyVettingSubStatus"></b-form-select></b-col>
                </b-row>
            </b-container>

            <template #modal-footer>
                <b-button size="sm" variant="secondary" @click="hideModal()">Cancel</b-button>
                <b-button size="sm" variant="success" @click="updateSubStatuses()">Save</b-button>
            </template>

        </b-modal>

        <b-modal size="md" centered title="Edit Distribution List" id="distribution-list">

            <p>Distribution list for <b>Order {{ this.orderNumber }}</b>:</p>

            <contact-select name="deliveryContactIds"
                            :api-url="apiControllerUrl('contact/delivery')"
                            :ref-data-api-controller-url="apiControllerUrl('referencedata')"
                            :client-id="orderingClientId"
                            v-model="currentDeliveryContactIds"
                            :initial-contacts="initialDeliveryContacts"
                            multiple>
            </contact-select>

            <p>CC list for <b>Order {{ this.orderNumber }}</b>:</p>

            <contact-select name="deliveryContactCcIds"
                            :api-url="apiControllerUrl('contact/delivery')"
                            :ref-data-api-controller-url="apiControllerUrl('referencedata')"
                            :client-id="orderingClientId"
                            v-model="currentCcDeliveryContactIds"
                            :initial-contacts="initialDeliveryContacts"
                            multiple>
            </contact-select>

            <p>BCC list for <b>Order {{ this.orderNumber }}</b>:</p>

            <contact-select name="deliveryContactBccIds"
                            :api-url="apiControllerUrl('contact/delivery')"
                            :ref-data-api-controller-url="apiControllerUrl('referencedata')"
                            :client-id="orderingClientId"
                            v-model="currentBccDeliveryContactIds"
                            :initial-contacts="initialDeliveryContacts"
                            multiple>
            </contact-select>

            <template #modal-footer>
                <b-button size="sm" variant="secondary" @click="hideModal()">Cancel</b-button>
                <b-button size="sm" variant="success" @click="updateDeliveryContacts()">Save</b-button>
            </template>

        </b-modal>

    </div>
</template>

<script>
    import moment from 'moment';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import ContactSelect from './ContactSelect.vue';
    import ErrorsMixin from '../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);
    Vue.component('contact-select', ContactSelect);

    export default {
        name: 'WorkitemOrders',
        mixins: [ErrorsMixin],
        model: {
            event: 'change',
            prop: 'toBeDelivered'
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            workItemId: {
                type: String,
                required: true
            },
            workItemCompleted: {
                type: Boolean,
                default: false
            },
            allAudioSubStatusOptions: {
                type: Array,
                default: null
            },
            allReleaseApprovalSubStatusOptions: {
                type: Array,
                default: null
            },
            allDepositSubStatusOptions: {
                type: Array,
                default: null
            },
            allLogNotesSubStatusOptions: {
                type: Array,
                default: null
            },
            allVettingSubStatusOptions: {
                type: Array,
                default: null
            },
            allDeliveredLateReasonOptions: {
                type: Array,
                default: null
            },
            canViewSubStatusDetails: {
                type: Boolean,
                default: false
            },
            canModifyAudioSubStatus: {
                type: Boolean,
                default: false
            },
            canModifyLogNotesSubStatus: {
                type: Boolean,
                default: false
            },
            canModifyReleaseApprovalSubStatus: {
                type: Boolean,
                default: false
            },
            canModifyDepositSubStatus: {
                type: Boolean,
                default: false
            },
            canModifyVettingSubStatus: {
                type: Boolean,
                default: false
            },
            canViewDeliveryContactDetails: {
                type: Boolean,
                default: false
            },
            canViewTurnarounds: {
                type: Boolean,
                default: false
            },
            canModifyDeliveryContacts: {
                type: Boolean,
                default: false
            },
            canResetDeliveredStatus: {
                type: Boolean,
                default: false
            },
            hideDeliveryInfo: {
                type: Boolean,
                default: false
            },
            forOrderDelivery: {
                type: Boolean,
                default: false
            },
            toBeDelivered: {
                type: Array,
                default: null
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                orders: [],
                
                currentErrors: [],

                selectedAudioSubStatus: null,
                selectedReleaseApprovalSubStatus: null,
                selectedDepositSubStatus: null,
                selectedLogNotesSubStatus: null,
                selectedVettingSubStatus: null,

                // used for <contact-select> in distribution list modal
                orderNumber: null,
                orderingClientId: null,
                initialDeliveryContacts: null,
                currentDeliveryContactIds: null,
                currentCcDeliveryContactIds: null,
                currentBccDeliveryContactIds: null,

                currentDeliveredLateReasonText: null,
                ordersToBeDelivered: this.toBeDelivered,

                showNoTranscriptAlert: false,
            };
        },
        computed: {
            fields: function () {
                var fieldArray = [];

                if (this.forOrderDelivery) {
                    fieldArray.push(
                        {
                            key: 'toBeDelivered',
                            label: '',
                            sortable: false
                        }
                    );
                }
                fieldArray.push(
                    {
                        key: 'order.orderNumberDisplayText',
                        label: 'Order Number',
                        sortable: true
                    }
                );
                fieldArray.push(
                    {
                        key: 'order.orderingClientName',
                        label: 'Ordering Client',
                        sortable: true
                    }
                );
                fieldArray.push(
                    {
                        key: 'clientReference',
                        label: 'Client Reference',
                        sortable: true
                    }
                );
                if (!this.forOrderDelivery) {
                    fieldArray.push(
                        {
                            key: 'order.orderedDateTimeUTC',
                            formatter: (value, key, item) => {
                                var orderedDateTimeUTC = item.order.orderedDateTimeUTC;
                                if (orderedDateTimeUTC == null) orderedDateTimeUTC = item.order.createdDateTimeUTC;
                                return moment.utc(orderedDateTimeUTC).local().format('DD/MM/YYYY hh:mmA');
                            },
                            label: 'Ordered',
                            sortable: true
                        }
                    );
                    fieldArray.push(
                        {
                            key: 'order.confirmedDateTimeUTC',
                            formatter: (value, key, item) => {
                                var confirmedDateTimeUTC = item.order.confirmedDateTimeUTC;
                                if (confirmedDateTimeUTC == null) return '';
                                return moment.utc(confirmedDateTimeUTC).local().format('DD/MM/YYYY hh:mmA');
                            },
                            label: 'Confirmed',
                            sortable: true
                        }
                    );
                    if (this.canViewTurnarounds) {
                        fieldArray.push(
                            {
                                key: 'serviceDelayName',
                                label: 'Turnaround',
                                sortable: true
                            }
                        );
                    }
                }
                fieldArray.push(
                    {
                        key: 'order.subStatusDisplayName',
                        label: 'Delivery State',
                        sortable: false
                    }
                );
                if (this.$config.enableTranscriptDeliveryOptions) {
                    fieldArray.push(
                        {
                            key: 'order.deliveryOptionsDisplayText',
                            label: 'Delivery Options',
                            sortable: true
                        }
                    );
                }
                if (!this.forOrderDelivery) {
                    fieldArray.push(
                        {
                            key: 'order.additionalCourtMatters',
                            label: 'Additional Matters',
                            sortable: false
                        }
                    );
                } // canViewDeliveryContactDetails
                if (!this.forOrderDelivery && !this.hideDeliveryInfo && this.canViewDeliveryContactDetails) {
                    fieldArray.push(
                        {
                            key: 'order.deliveryContacts',
                            label: 'Distribution List',
                            sortable: false
                        }
                    );
                }
                
                return fieldArray;
            },
        },
        methods: {

            formatSubStatusString: function (substatusString) {
                return substatusString.replaceAll(',', '<br>');
            },

            apiControllerUrl: function (apiRelativeUrl) {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += apiRelativeUrl;
                return url;
            },

            editSubStatus: function (order) {  // whole order coming in from clicking button of order grid

                // the 4 v-models for the drop downs in popup
                this.selectedAudioSubStatus = order.audioSubStatus.stringValue;
                this.selectedDepositSubStatus = order.depositSubStatus.stringValue;
                this.selectedLogNotesSubStatus = order.logNotesSubStatus.stringValue;
                this.selectedReleaseApprovalSubStatus = order.releaseApprovalSubStatus.stringValue;
                this.selectedVettingSubStatus = order.vettingSubStatus.stringValue;

                this.currentOrderId = order.orderId;
                this.orderNumber = order.orderNumberDisplayText;
                this.$bvModal.show('sub-status-modal');
                this.$emit('modalOpen', true);
            },
            updateSubStatuses: function () {
                                
                var statusObject = {};
                statusObject.audioSubStatus = this.selectedAudioSubStatus;
                statusObject.releaseApprovalSubStatus = this.selectedReleaseApprovalSubStatus;
                statusObject.depositSubStatus = this.selectedDepositSubStatus;
                statusObject.logNotesSubStatus = this.selectedLogNotesSubStatus;
                statusObject.vettingSubStatus = this.selectedVettingSubStatus;

                this.currentErrors = [];
                if (this.currentOrderId) {
                    axios
                        .request(
                            {
                                method: 'put',
                                url: this.apiControllerUrl('order') + '/updatesubstatus/' + this.currentOrderId,
                                data: JSON.stringify(statusObject),
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                        })
                        .then(response => {
                            console.log(response);
                            this.hideModal();
                            this.reload();
                        })
                        .catch(ex => {
                            this.currentErrors = this.handleAxiosException(ex);
                        })
                        .finally(() => {
                            if (this.currentErrors.length != 0) {
                                this.showErrorsToast(this.currentErrors);
                            }
                        });
                }
            },

            resetDeliveredStatus: function (order) {
                this.$bvModal.msgBoxConfirm([this.$createElement('div',
                    {
                        domProps:
                        {
                            innerHTML: 'Are you sure you want to reset the delivered status for<br/><b>Order ' + order.orderNumberDisplayText + '</b>?<br/><br/>This action cannot be undone!'
                        }
                    })],
                    {
                    title: 'Confirm Reset Delivered Status',
                    size: 'md',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    centered: true
                    })
                    .then(value => {
                        if (value) {
                            axios
                                .get(this.apiControllerUrl('workitem') + '/resetdelivered/' + this.workItemId + '/' + order.orderId)
                                .then(() => {
                                    this.reload();
                                })
                                .catch(ex => {
                                    var currentErrors = this.handleAxiosException(ex);
                                    this.showErrorsToast(currentErrors);
                                });
                        }
                    });
            },

            renderDeliveryContacts: function (inArray) {

                var deliveryContactString = '';
                inArray.forEach(function (element) {
                    deliveryContactString += '' + element.name + '<br>'
                });
                return deliveryContactString;
            },
            editDistributionList: function (item) {

                this.orderingClientId = item.order.orderingClientId;
                this.currentOrderId = item.order.orderId;
                this.orderNumber = item.order.orderNumberDisplayText;
                this.initialDeliveryContacts = item.deliveryContacts;
                this.currentDeliveryContactIds = [];
                this.currentCcDeliveryContactIds = [];
                this.currentBccDeliveryContactIds = [];

                item.deliveryContacts.forEach((element) => {
                    if (element.deliveryContactType == "Cc") this.currentCcDeliveryContactIds.push(element.contactId);
                    else if (element.deliveryContactType == "Bcc") this.currentBccDeliveryContactIds.push(element.contactId);
                    else this.currentDeliveryContactIds.push(element.contactId);
                });
                this.$bvModal.show('distribution-list');
                this.$emit('modalOpen', true);
            },
            updateDeliveryContacts: function () {

                var data = {
                    workItemId: this.workItemId,
                    deliveryContactIds: this.currentDeliveryContactIds,
                    ccDeliveryContactIds: this.currentCcDeliveryContactIds,
                    bccDeliveryContactIds: this.currentBccDeliveryContactIds,
                }
                this.currentErrors = [];
                if (this.currentOrderId) {
                    axios
                        .request(
                            {
                                method: 'put',
                                url: this.apiControllerUrl('order') + '/updatedeliverycontacts/' + this.currentOrderId,
                                data: JSON.stringify(data),
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })
                        .then(response => {
                            console.log(response);
                            this.hideModal();
                            this.reload();
                        })
                        .catch(ex => {
                            this.currentErrors = this.handleAxiosException(ex);
                        })
                        .finally(() => {
                            if (this.currentErrors.length != 0) {
                                this.showErrorsToast(this.currentErrors);
                            }
                        });
                }
            },

            copyTranscriptLinkToClipboard: function(item) {
                navigator.clipboard.writeText(item.transcriptLink);

                this.$bvToast.toast('Link to Transcript copied to clipboard', {
                    title: 'Copy to Clipboard',
                    variant: 'success',
                    appendToast: true
                });
            },

            editDeliveredLateReasonText: function (item) {
                this.currentOrderId = item.order.orderId;
                this.currentDeliveredLateReasonText = item.deliveredLateReasonText;
                this.$bvModal.show('delivered-late-reason-text');
                this.$emit('modalOpen', true);
            },
            updateDeliveredLateReasonText: function () {
                var item = this.orders.find((i) => i.order.orderId == this.currentOrderId);
                item.deliveredLateReasonText = this.currentDeliveredLateReasonText;
                this.hideModal();
                this.ordersToBeDeliveredChanged();
            },

            hideModal: function () {
                this.$bvModal.hide('sub-status-modal');
                this.$bvModal.hide('distribution-list');
                this.$bvModal.hide('delivered-late-reason-text');

                this.$emit('modalOpen', false);
            },

            reload: function () {
                var promises = [];
                promises.push(this.reloadOrders());
                return Promise.all(promises);
            },
            reloadOrders: function () {
                this.currentErrors = [];
                if (this.workItemId) {
                    return axios
                        .get(this.apiControllerUrl('order') + '/byworkitem/' + this.workItemId + '/list')
                        .then(response => {
                            if (this.forOrderDelivery) {

                                this.orders = response.data.map((item) => {
                                    item.toBeDelivered = !item.delivered && (item.order.subStatusDeliveryState !== false);
                                    item.copiesDelivered = null;
                                    item.deliveredOnTime = true;
                                    item.deliveredLateReason = "";
                                    item.deliveredLateReasonText = null;
                                    item['_showDetails'] = true;

                                    return item;
                                });
                                this.ordersToBeDeliveredChanged();

                                this.showNoTranscriptAlert = false;
                                this.$emit('showNoTranscriptAlert', this.showNoTranscriptAlert);

                                this.orders.forEach((element) => {
                                    var transcriptLink = element.transcriptLink;
                                    var deliveryType = element.deliveryType;
                                    if (transcriptLink == "" && deliveryType > 0) {
                                        this.showNoTranscriptAlert = true;
                                        this.$emit('showNoTranscriptAlert', this.showNoTranscriptAlert);
                                    }
                                });
                            } else {
                                this.orders = response.data;
                            }
                        })

                        .catch(ex => {
                            this.currentErrors = this.handleAxiosException(ex);
                        })
                        .finally(() => {
                            if (this.currentErrors.length != 0) {
                                this.showErrorsToast(this.currentErrors);
                            }
                        });
                }
                return Promise.resolve();
            },
            
            deliveredLateReasonChanged: function (item) {
                this.ordersToBeDeliveredChanged();
                if (item.deliveredLateReason == "Other" ||
                    item.deliveredLateReason == "TechnicalIssues" ||
                    item.deliveredLateReason == "AdministrativeDelays") this.editDeliveredLateReasonText(item);
            },
            ordersToBeDeliveredChanged: function () {
                this.ordersToBeDelivered = [];
                if (this.orders != null) {
                    this.orders.forEach((item) => {
                        if (item.toBeDelivered) {
                            this.ordersToBeDelivered.push(
                                {
                                    orderId: item.order.orderId,
                                    copiesDelivered: item.copiesDelivered,
                                    deliveredOnTime: item.deliveredOnTime,
                                    deliveredLateReason: item.deliveredLateReason,
                                    deliveredLateReasonText: item.deliveredLateReasonText,
                                }
                            );
                        }
                    });
                }
                this.$emit('change', this.ordersToBeDelivered);
            }
        },

        mounted: function () {
            this.reload();
        }
    }
</script>